import { useRef, } from 'react';
import './mediumArticles.css';
import { ChevronLeft, ChevronRight } from 'lucide-react';

function MediumArticles() {
  const scrollRef = useRef(null);

  const articles = [
    {
      title: "Particle Swarm Optimization",
      image: "https://miro.medium.com/v2/resize:fit:4800/format:webp/1*5ry-SsDbuizme8Pc9H1IXw.jpeg",
      date: "November 2024",
      link: "https://medium.com/@Loubna-DS/particle-swarm-optimization-pso-61cd637f28d4",
    },
    {
      title: "What is Sequential Quadratic Programming",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*4DK0WlQtxtFIea0Z",
      date: "November 2024",
      link: "https://medium.com/@Loubna-DS/what-is-sequential-quadratic-programming-sqp-4d5a34b4d53b",
    },
    {
      title: "Understanding Random Forest",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*Y_O3pk2yFixQUSHyU_Cg0A.gif",
      date: "October 2024",
      link: "https://medium.com/@Loubna-DS/understanding-random-forest-7230a9fd95bc",
    },
    {
      title: "Classification with Decision Trees",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*qRMO5wuNovshpEHJ",
      date: "October 2024",
      link: "https://medium.com/@Loubna-DS/classification-with-decision-trees-488ce99823f1",
    },
    {
      title: "How to deal with Rejections-Academia",
      image: "https://miro.medium.com/v2/resize:fit:4800/format:webp/1*R_0-oQY4cxMbQFLGXmOkFQ.png",
      date: "April 2025",
      link: "https://medium.com/@Loubna-DS/how-to-deal-with-rejections-academia-1ed6da259621",
    },
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += direction === 'left' ? -350 : 350;
    }
  };

  return (
    <section className="medium-articles">
      <div className="articles-container">
        <h2 className="articles-heading">
          Read My Most <span className="highlight">Popular Articles</span>
        </h2>

        <div className="scroll-buttons">
          <button onClick={() => scroll('left')} className="scroll-btn" aria-label="Scroll left">
            <ChevronLeft size={20} />
          </button>
          <button onClick={() => scroll('right')} className="scroll-btn" aria-label="Scroll right">
            <ChevronRight size={20} />
          </button>
        </div>

        <div className="articles-scroll" ref={scrollRef}>
          {articles.map((article, index) => (
            <a
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              className="article-card"
              key={index}
            >
              <div className="article-image-wrapper">
                <img
                  loading="lazy"
                  src={article.image}
                  onError={(e) => (e.currentTarget.src = "/fallback.jpg")}
                  alt={article.title}
                  className="article-image"
                />
                <div className="image-overlay" />
              </div>
              <div className="article-content">
                <p className="article-date">{article.date}</p>
                <h3 className="article-title">{article.title}</h3>
                <span className="read-more">Read more →</span>
              </div>
            </a>
          ))}
        </div>

        <a
          href="https://medium.com/@Loubna-DS"
          className="hero-btn explore-medium"
          target="_blank"
          rel="noopener noreferrer"
        >
          Explore All on Medium →
        </a>
      </div>
    </section>
  );
}

export default MediumArticles;
